export default "__VITE_ASSET__BDWT5KRe__"